export default "__VITE_ASSET__BuVkThSi__"